<template>
  <v-app id="app" toolbar>
    <header-nav />
    <main>
      <v-container fluid>
        <router-view />
      </v-container>
    </main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/Header'
import BaseComponent from '@/components/BaseComponent'

export default {
  name: 'app',
  extends: BaseComponent,
  components: {
    'header-nav': Header
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  created () {
    this.$router.beforeEach((to, from, next) => {
      this.guardRoute(to, from, next)
    })
  },
  methods: {
    // グローバルルーティングガード
    guardRoute (to, from, next) {
      if (to.name === 'Top') {
        if (this.currentUser) {
          next({name: 'Chat'})
        } else {
          next()
        }
      } else {
        next()
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, 'Meiryo', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* Veutifyデフォルトのスタイルによりツールバーの高さ分Viewportから下にはみ出るのを修正 */
.toolbar--fixed+main {
  padding-top: 0px;
}
.application>main>.container {
  padding-top: 76px;
}

.chat-input textarea:disabled {
  background-color: gray;
}
.chat-input button:disabled {
  background-color: gray !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue?6281ba36